import useRateChange from '@/hooks/useRateChange'
import { Flex } from '@mantine/core'
import type { BasePriceItem } from 'api-price'
import dayjs from 'dayjs'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import useLangPrefix from '@/hooks/useLangPrefix'
import { PriceNewStyled } from './style'
import { useAdapter } from '@/components/Adapter'
import Change from '../Change'
import dynamic from 'next/dynamic'
import { bigNumberMultipliedBy } from '@/utils/tools'
const CountDown = dynamic(() => import('./CountDown'), {
  ssr: false,
})

const Price: FC<BasePriceItem & { isFundraising?: boolean; onTimeEnd: (item: BasePriceItem) => void }> = props => {
  const { isFundraising, price, time, fiat, onTimeEnd } = props
  const { formatRateChangePrice } = useRateChange()
  const { t } = useTranslation()
  const { isZh } = useLangPrefix()
  const { isH5 = false } = useAdapter()

  if (isFundraising) {
    return <span className="text-1 size-16 font-500">{formatRateChangePrice(price, { isThousands: true })}</span>
  }

  if (time && !dayjs().isAfter(dayjs(time * 1000))) {
    return (
      <PriceNewStyled className="price-new-left">
        <Flex miw={190} direction="column" gap={8} data-new={String(Boolean(time))}>
          <span className="size-12 font-400 text-funct-4">
            {t('P.OpeningTime')}
            {isZh ? '：' : ': '}
            {dayjs(time * 1000).format('YYYY-MM-DD HH:mm:ss')}
          </span>

          <span className="text-funct-4 size-14 font-400">
            <CountDown onEnd={() => void onTimeEnd(props)} time={time ?? 0} />
          </span>
        </Flex>
      </PriceNewStyled>
    )
  }

  if (isH5) {
    return (
      <Flex direction="column" gap={4}>
        <span className="text-1 size-16 font-500">
          {fiat?.symbol ?? ''}
          {formatRateChangePrice(bigNumberMultipliedBy(price, fiat?.rate ?? '1'), { isUnit: !fiat?.symbol })}
        </span>
        <Change {...props} />
      </Flex>
    )
  }

  return (
    <span className="text-1 size-16 font-500">
      {fiat?.symbol ?? ''}
      {formatRateChangePrice(bigNumberMultipliedBy(price, fiat?.rate ?? '1'), { isUnit: !fiat?.symbol })}
    </span>
  )
}

export default observer(Price)
